import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SvgIcon } from "@mui/material";

const customToastify = (
  type,
  message,
  time = 5000,
  position = "bottom-center"
) => {
  const options = {
    position,
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  if (type == "info") {
    toast.info(message, options);
    // console.log("type,message", type, message);
  } else if (type == "success") toast.success(message, options);
  else if (type == "warning") toast.warning(message, options);
  else if (type == "error") toast.error(message, options);
  else toast(message, options);
};

const checkErrorMessage = (err) => {
  let errorDetails = { message: false, params: false, titles: false };
  if (
    err &&
    err["response"] &&
    err["response"]["data"] &&
    err["response"]["data"]["data"]
  ) {
    if (err["response"]["data"]["data"]["titles"])
      errorDetails.titles =
        err["response"]["data"]["data"]["titles"].join(" - ");
    if (err["response"]["data"]["data"]["params"])
      errorDetails.params = err["response"]["data"]["data"]["params"];
  } else if (
    err &&
    err["response"] &&
    err["response"]["data"] &&
    err["response"]["data"]["message"]
  ) {
    errorDetails.message = err["response"]["data"]["message"];
  } else {
    errorDetails.message = "لطفا بعدا تلاش کنید";
  }
  return errorDetails;
};

const checkResponseData = (response) => {
  let responseDetails = { success: false, message: false, data: false };
  if (response && response["data"] && response["data"]["success"]) {
    if (response["data"]["message"])
      responseDetails.message = response["data"]["message"];
    if (response["data"]["data"])
      responseDetails.data = response["data"]["data"];
    responseDetails.success = true;
  }
  return responseDetails;
};

function LoadingSvg() {
  return (
    <SvgIcon viewBox="0 0 120 120">
      <g>
        <path
          d="M50 15A35 35 0 1 0 74.74873734152916 25.251262658470843"
          fill="none"
          stroke="#e15b64"
          strokeWidth="12"
        ></path>
        <path d="M49 3L49 27L61 15L49 3" fill="#e15b64"></path>
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </g>
    </SvgIcon>
  );
}

export { customToastify, checkErrorMessage, checkResponseData, LoadingSvg };
